<template>
    <v-container id="temas-cjg">
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="alineacentro DatosMatriculado">
            <v-card-title class="DatosMatriculado">
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card
                    dark
                    color="success"
                    class="alineacentro DatosMatriculado"
                  >
                    <strong>CJG - TEMAS Y SUBTEMAS</strong>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col>
                  <v-spacer />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Listar"
                    @click="listar"
                    :disabled="!permisolectura"
                  >
                    <v-icon dark> mdi-magnify </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2"
                    x-small
                    color="blue"
                    title="Agregar Tema"
                    @click="agregar"
                    :disabled="!permisoescritura"
                  >
                    <v-icon dark> mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-data-table
                    :headers="columnas"
                    :items="lista"
                    :items-per-page="10"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    item-key="idtema"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                    multi-sort
                  >
                    <template v-slot:item.actions="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            x-small
                            icon
                            color="green"
                            @click="editar(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="!permisoescritura || item.idestado===2"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>
                      &nbsp;
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            x-small
                            icon
                            color="black"
                            @click="subtemas(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="!permisoescritura || item.idestado===2"
                          >
                            <v-icon>mdi-playlist-edit</v-icon>
                          </v-btn>
                        </template>
                        <span>Subtemas</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:item.validezhastadmy="{ item }">
                      <v-chip v-if="item.validezhastadmy!=null && item.validezhastadmy.length>0" color="red" dark>
                        <p class="textofilagrilla">{{ item.validezhastadmy }}</p>
                      </v-chip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialognuevo" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">
            {{dialognuevotitulo}}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="guardar">
                    Guardar
                </v-btn>
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialognuevo = false"
                >
                    Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br/>
            <br/>
            <v-row row wrap>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" md="8" lg="8">
                <v-text-field
                  v-model="editedtema.nombre"
                  label="Nombre"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="4" lg="4">
                <v-menu
                  v-model="menuvalidezhastatema"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalvalhastatema"
                      label="Validez Hasta"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      height="20px"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editedtema.validezhasta"
                    @input="menuvalidezhastatema = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogsubtema" persistent max-width="1024">
        <v-card>
          <v-card-title class="headline">
            {{dialogsubtematitulo}}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="red darken-1" text @click="dialogsubtema = false">Cerrar</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br/>
            <br/>
            <v-row class="text-center">
              <v-col cols="12">
                <v-btn
                  class="ma-2"
                  dark
                  x-small
                  color="primary"
                  title="Listar"
                  @click="listarsubtemas(false)"
                  :disabled="!permisolectura"
                >
                  <v-icon dark> mdi-magnify </v-icon>
                </v-btn>
                <v-btn
                  class="ma-2"
                  x-small
                  color="blue"
                  title="Agregar SubTema"
                  @click="agregarsubtema"
                  :disabled="!permisoescritura"
                >
                  <v-icon dark> mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-data-table
                  :headers="columnassubtemas"
                  :items="listasubtemas"
                  :items-per-page="10"
                  :footer-props="{
                    'items-per-page-text': 'Filas por Página:',
                    'items-per-page-all-text': 'Todos',
                  }"
                  item-key="idsubtema"
                  class="elevation-1"
                  dense
                  no-data-text="Sin Registros"
                  multi-sort
                >
                  <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          icon
                          color="green"
                          @click="editarsubtema(item)"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="!permisoescritura"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:item.validezhastadmy="{ item }">
                    <v-chip v-if="item.validezhastadmy!=null && item.validezhastadmy.length>0" color="red" dark>
                        <p class="textofilagrilla">{{ item.validezhastadmy }}</p>
                      </v-chip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialognuevosubtema" persistent max-width="300">
        <v-card>
          <v-card-title class="headline">
            {{dialognuevosubtematitulo}}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="guardarsubtema">
                    Guardar
                </v-btn>
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialognuevosubtema = false"
                >
                    Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br/>
            <br/>
            <v-row row wrap>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" md="8" lg="8">
                <v-text-field
                  v-model="editedsubtema.nombre"
                  label="Nombre"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="4" lg="4">
                <v-menu
                  v-model="menuvalidezhastasubtema"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalvalhastasubtema"
                      label="Validez Hasta"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      height="20px"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editedsubtema.validezhasta"
                    @input="menuvalidezhastasubtema = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogmensaje" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">
            {{ mensajetitulo }}
          </v-card-title>
          <v-card-text>
            {{ mensajecuerpo }}
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green darken-1" text @click="dialogmensaje = false; if(mensajehome===true){$router.push('Home')}">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width>
        <v-container
          fluid
          class="full-height"
          style="background-color: rgba(255, 255, 255, 0.5)"
        >
          <v-row
            align="center"
            justify="center"
            style="height: 100vh"
            no-gutters
            dense
          >
            <v-col class="elementocentrado">
              <v-progress-circular indeterminate color="primary" />
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
      <ConfirmDlg ref="confirm" />
    </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
export default {
  name: "temasysubtemas",
  components: {
    ConfirmDlg: ConfirmDlg,
  },
  data() {
    return {
      loading: false,
      usuario: "",
      permisolectura: false,
      permisoescritura: false,
      nromodulo: 58,
      dialogmensaje: false,
      mensajetitulo: "",
      mensajecuerpo: "",
      mensajehome: false,
      columnas: [
        {
            text: "Op.",
            value: "actions",
            width: 120
        },
        {
            text: "ID",
            align: "center",
            sortable: true,
            value: "idtema",
            width: 80
        },
        {
            text: "Nombre",
            align: "center",
            sortable: true,
            value: "nombre",
            width: 400
        },
        {
            text: "Validez Hasta",
            align: "center",
            sortable: true,
            value: "validezhastadmy",
            width: 120
        }
      ],
      lista: [],
      dialognuevo: false,
      dialognuevotitulo: '',
      editedtema: {
        idtema: 0,
        nombre: '',
        validezhasta: null,
        usuario: ''
      },
      listasubtemas: [],
      columnassubtemas: [
        {
            text: "Op.",
            value: "actions",
            width: 60
        },
        {
            text: "ID",
            align: "center",
            sortable: true,
            value: "idsubtema",
            width: 60
        },
        {
            text: "Nombre",
            align: "left",
            sortable: true,
            value: "nombre",
            width: 180
        },
        {
            text: "Validez Hasta",
            align: "center",
            sortable: true,
            value: "validezhastadmy",
            width: 120
        }
      ],
      dialogsubtema: false,
      dialogsubtematitulo: '',
      subtemaidtema: 0,
      dialognuevosubtema: false,
      dialognuevosubtematitulo: '',
      editedsubtema: {
        idsubtema: 0,
        nombre: '',
        idtema: 0,
        validezhasta: null,
        usuario: ''
      },
      menuvalidezhastatema: false
    };
  },
  mounted() {
    this.loading = true;
    this.usuario = localStorage.getItem("user");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    var roles= localStorage.getItem('rolesusuario')
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion===1);
    if (existeper.length === 0) {
      this.loading = false;
      this.MostrarMensaje("Error","No tiene permisos para acceder a este módulo.",true);
    } else {
      this.permisolectura= permisos.filter(p=> p.nromodulo===this.nromodulo && (roles.includes(p.idrol) || p.usuario===this.usuario) && p.idaccion===9).length>0 ? true : false;
      this.permisoescritura= permisos.filter(p=> p.nromodulo===this.nromodulo && (roles.includes(p.idrol) || p.usuario===this.usuario) && (p.idaccion>1 && p.idaccion<9)).length>0 ? true : false;
      this.loading = false;
    }
  },
  methods: {
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    listar () {
      this.loading=true;
      axios.post("cjg/PostListaTemas", { headers: { "Content-Type": "application/json" }}).then((result) => {
        if(result.data.resultado===0){
          this.lista = result.data.datos;
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    agregar () {
      this.editedtema= {
        idtema: 0,
        nombre: '',
        validezhasta: null,
        usuario: this.usuario
      };
      this.dialognuevotitulo='Nuevo Tema';
      this.dialognuevo= true;
    },
    editar (item) {
      this.editedtema= {
        idtema: item.idtema,
        nombre: item.nombre,
        validezhasta: item.validezhastaymd,
        usuario: this.usuario
      };
      this.dialognuevotitulo='Editando Tema ID ' + item.idtema.toString();
      this.dialognuevo= true;
    },
    subtemas (item) {
      this.dialogsubtematitulo='Subtemas del Tema ' + item.idtema.toString() + ' - ' + item.nombre;
      this.subtemaidtema= item.idtema;
      this.listarsubtemas(item, true);
    },
    listarsubtemas(abrirdialog) {
      this.loading=true;
      axios.post("cjg/PostListaSubTemas",{idtema: this.subtemaidtema}, { headers: { "Content-Type": "application/json" }}).then((result) => {
        if(result.data.resultado===0){
          this.listasubtemas = result.data.datos;
          if(abrirdialog) {
            this.dialogsubtema= true;
          }
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    guardar () {
      this.loading= true;
      const cons = JSON.stringify(this.editedtema);
      axios.post("cjg/PostTema", cons, { headers: { "Content-Type": "application/json" },}).then((result) => {
        if (result.data.resultado === 0) {
          this.dialognuevo = false;
          this.listar();
        } else {
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadoMensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    /* getColorTema(activo) {
      if (activo === true) return "green";
      else return "red";
    }, */
    agregarsubtema () {
      this.editedsubtema= {
        idsubtema: 0,
        nombre: '',
        idtema: this.subtemaidtema,
        validezhasta: null,
        usuario: this.usuario
      };
      this.dialognuevosubtematitulo='Nuevo Subtema';
      this.dialognuevosubtema= true;
    },
    editarsubtema (item) {
      this.editedsubtema= {
        idsubtema: item.idsubtema,
        nombre: item.nombre,
        idtema: item.idtema,
        validezhasta: item.validezhastaymd,
        usuario: this.usuario
      };
      this.dialognuevosubtematitulo='Editando SubTema ID ' + item.idsubtema.toString();
      this.dialognuevosubtema= true;
    },
    guardarsubtema () {
      this.loading= true;
      const subt = JSON.stringify(this.editedsubtema);
      axios.post("cjg/PostSubTema", subt, { headers: { "Content-Type": "application/json" },}).then((result) => {
        if (result.data.resultado === 0) {
          this.dialognuevosubtema = false;
          this.listarsubtemas(false);
        } else {
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
  },
  computed: {
    fechalocalvalhastatema: function () {
      if (this.editedtema.validezhasta != null && this.editedtema.validezhasta != "") {
        var fecha = new Date(this.editedtema.validezhasta);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocalvalhastasubtema: function () {
      if (this.editedsubtema.validezhasta != null && this.editedsubtema.validezhasta != "") {
        var fecha = new Date(this.editedsubtema.validezhasta);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    }
  },
};
</script>
<style>
/*.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.680rem !important;
    height: 25px !important;
}*/

.hide-toolbar .ql-toolbar {
    padding: 0;
    border-bottom: hidden;
    span {
        display: none;
    }
}

.ql-font-roboto {
  font-family: 'Roboto', sans-serif;
}

.editor {
    height: 40rem;
    overflow: hidden;
}

.textofilagrilla {
  font-size: 0.680rem !important;
  height: 5px !important;
}

.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa10 {
  width: 10%;
}
.ocupa20 {
  width: 20%;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
</style>